import type { PriorityCardGroupKey } from "@types";
import type { InsightCategory } from "../types";

/** Mapeia `InsightCategory` (API) para a chave em ingles usada nos cards, abas e URL (`tab`). */
export const insightCategoryToGroupKey = (
	category: InsightCategory
): PriorityCardGroupKey => {
	if (category === 1) {
		return "reminders";
	}

	if (category === 2) {
		return "alerts";
	}

	return "opportunities";
};
